import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-213">
      {children}
    </div>;
}
interface RoadmapItemData {
  emoji: string;
  hour: string;
  painLabel: string;
  thought: string;
  solution: string;
}
export function RoadmapSection() {
  return <section className="bg-white py-20 px-5" data-id="element-214">
      <div className="max-w-[760px] mx-auto" data-id="element-215">
        <RevealBlock data-id="element-216">
          <p className="text-[0.8rem] font-bold tracking-[2px] uppercase text-verde-bosque mb-3 flex items-center gap-2" data-id="element-217">
            <span className="w-6 h-0.5 bg-verde-bosque rounded-sm" data-id="element-218" />
            El día de Laura (Tu historia)
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-219">
          <h2 className="font-display font-bold text-negro-carbon leading-[1.25] mb-6" style={{
          fontSize: 'clamp(1.6rem, 4vw, 2.4rem)'
        }} data-id="element-220">
            Lo que tu cuerpo vive
            <br data-id="element-221" />
            <span className="text-verde-bosque" data-id="element-222">cada 24 horas sin saberlo</span>
          </h2>
        </RevealBlock>

        <RevealBlock data-id="element-223">
          <div className="relative py-5" data-id="element-224">
            {/* Timeline line */}
            <div className="absolute left-6 md:left-[50px] top-0 bottom-0 w-[3px] rounded-sm" style={{
            background: 'linear-gradient(180deg, #2B4A42, #C9A84C)'
          }} data-id="element-225" />

            <RoadmapItem emoji="☀️" hour="07:00 AM" painLabel="Momento de dolor" thought='"¿De dónde salió esta barriga si ayer casi no comí?"' solution="El Protocolo del Espejo: Identifica tu tipo de grasa y ataca la causa real." data-id="element-226" />
            <RoadmapItem emoji="☕" hour="08:00 AM" painLabel="Error #1 del día" thought='"Necesito mi café negro para funcionar... aunque me inflame."' solution="La Bebida Adrenal-Stop: Cómo preparar tu metabolismo ANTES del café." data-id="element-227" />
            <RoadmapItem emoji="🧠" hour="11:00 AM" painLabel="La niebla mental" thought='"No puedo concentrarme. Siento que mi cabeza está llena de algodón."' solution="Reseteo de Insulina Matutino: Energía estable sin necesidad de cafeína adicional." data-id="element-228" />
            <RoadmapItem emoji="⚡" hour="04:00 PM" painLabel='El "Crash" de la tarde' thought='"Daría lo que fuera por algo dulce o un trozo de pan. Mi voluntad desapareció."' solution="La Técnica del Muro de Glucosa: Cómo comer en el almuerzo para no colapsar a las 4 PM." data-id="element-229" />
            <RoadmapItem emoji="🌙" hour="08:00 PM" painLabel="El momento del espejo (de noche)" thought='"Me quito la ropa y odio lo que veo. ¿Cuándo perdí el control de mi propio cuerpo?"' solution="Protocolo de Apagado Adrenal: Baja el cortisol y activa la quema de grasa nocturna." data-id="element-230" />
            <RoadmapItem emoji="😴" hour="11:00 PM" painLabel="Insomnio de cortisol" thought='"Tengo el cuerpo agotado pero la mente no para. Mañana estaré peor."' solution='El Suplemento de $10: Magnesio Bisglicinato para apagar la "mente de estrés" y dormir profundo.' isLast data-id="element-231" />
          </div>
        </RevealBlock>
      </div>
    </section>;
}
function RoadmapItem({
  emoji,
  hour,
  painLabel,
  thought,
  solution,
  isLast = false
}: RoadmapItemData & {
  isLast?: boolean;
}) {
  return <div className={`flex gap-4 md:gap-7 items-start relative ${isLast ? '' : 'mb-7'}`} data-id="element-232">
      {/* Time column */}
      <div className="min-w-[52px] md:min-w-[100px] text-center" data-id="element-233">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-lg md:text-xl mx-auto relative z-10" style={{
        background: 'linear-gradient(135deg, #2B4A42, #3D6358)',
        boxShadow: '0 4px 16px rgba(43, 74, 66, 0.3)'
      }} data-id="element-234">
          {emoji}
        </div>
        <div className="text-[0.75rem] font-bold text-verde-bosque mt-1.5 tracking-wider" data-id="element-235">
          {hour}
        </div>
      </div>

      {/* Content card */}
      <div className="bg-white rounded-card py-5 px-[22px] shadow-suave border border-gray-200 flex-1 transition-all duration-300 hover:border-verde-bosque hover:shadow-fuerte" data-id="element-236">
        <div className="text-[0.78rem] font-bold tracking-[1px] uppercase text-rojo-urgencia mb-1.5" data-id="element-237">
          {painLabel}
        </div>
        <p className="italic text-gray-700 text-[0.95rem] mb-2.5 leading-relaxed" dangerouslySetInnerHTML={{
        __html: thought
      }} data-id="element-238" />
        <div className="text-[0.85rem] text-verde-bosque font-semibold flex items-center gap-1.5" data-id="element-239">
          <span className="bg-verde-menta text-verde-bosque w-5 h-5 rounded-full flex items-center justify-center text-[0.7rem] font-bold flex-shrink-0" data-id="element-240">
            ✓
          </span>
          {solution}
        </div>
      </div>
    </div>;
}